import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
	applicationCreateIV: [],
};

export const applicationCreateSlice = createSlice({
	name: 'applicationCreate',
	initialState,
	reducers: {
		reducerApplicationCreateIV: (state: Draft<any>, action: PayloadAction<any>) => {
		  state.applicationCreateIV = action.payload;
		},
	},
});

export const { reducerApplicationCreateIV } = applicationCreateSlice.actions;

export default applicationCreateSlice.reducer;
